import React from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorBoundaryProps {
    children: React.ReactNode;
    message: string;
    retry: string;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundaryClass extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('[ErrorBoundary]', error, errorInfo);
    }

    handleRetry = () => {
        if (typeof window !== 'undefined') window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <section className="space-ptb">
                    <div className="container">
                        <div className="alert alert-danger d-flex align-items-center justify-content-center flex-wrap" role="alert">
                            <span>{this.props.message}</span>
                            <button type="button" className="btn btn-sm btn-outline-danger mt-2 mt-sm-0 ml-3" onClick={this.handleRetry}>
                                {this.props.retry}
                            </button>
                        </div>
                    </div>
                </section>
            );
        }
        return this.props.children;
    }
}

const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return <ErrorBoundaryClass message={t('errorBoundary.message')} retry={t('errorBoundary.retry')}>{children}</ErrorBoundaryClass>;
};

export default ErrorBoundary;